import "./module/userAgentChecker.min.js"
import "./module/plugin.js"
import "./module/modal-multi.js"

import objectFitImages from 'object-fit-images';
objectFitImages();

import Swiper from 'swiper/bundle';
var myswiper01 = new Swiper('.mv__slider', {
  slidesPerView: 'auto',
  spaceBetween: 120,
  centeredSlides: true,
  loop: true,
  speed: 1500,
  initialSlide: 4,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1025: {
      spaceBetween: 40,
    }
  }
});

var myswiper02 = new Swiper('.home__blockInnerSlider', {
  slidesPerView: 1,
  spaceBetween: 60,
  centeredSlides: true,
  loop: true,
  speed: 1500,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1025: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    }
  }
});

/*var myswiper03 = new Swiper('.single__eyeInnerSlider', {
  slidesPerView: 2,
  spaceBetween: 100,
  //centeredSlides: true,
  speed: 1500,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1025: {
      //slidesPerView: 2,
      spaceBetween: 100,
      centeredSlides: false,
    }
  }
});*/

var myswiper04 = new Swiper('.single__BlockInnerSlider', {
  slidesPerView: 2,
  spaceBetween: 100,
  speed: 1500,
  //loop: true,
  initialSlide: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    667: {
      slidesPerView: 3,
      centeredSlides: true,
    }
  }
});